import { render, staticRenderFns } from "./SharedDashboard.vue?vue&type=template&id=28ce58b5&"
import script from "./SharedDashboard.vue?vue&type=script&lang=js&"
export * from "./SharedDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SharedDashboard.vue"
export default component.exports